import { PROVINCES } from '@/constants';

export default () => ({
  currentProvince: PROVINCES.AB,
});
